import { ComboBox as KendoComboBox, ComboBoxProps as KendoComboBoxProps } from '@progress/kendo-react-dropdowns';
import styled, { css } from 'styled-components';

export type {
    ComboBoxBlurEvent,
    ComboBoxFilterChangeEvent,
    ListItemProps,
    ComboBoxChangeEvent,
    ComboBoxCloseEvent,
    ComboBoxFocusEvent,
    ComboBoxPageChangeEvent,
    ComboBoxOpenEvent,
} from '@progress/kendo-react-dropdowns';

export interface ComboBoxProps extends KendoComboBoxProps {}

export const ComboBox = styled(KendoComboBox).attrs<ComboBoxProps>((props) => ({ className: 'app-combobox' }))`
    &&.app-combobox {
        font-size: 1em;
        width: 100% !important;
        font-style: normal;
        font-weight: normal;
        line-height: 1.071em;
        color: ${(props) => props.theme.colors.base_grey};
        box-shadow: none;
        border-radius: 0;
        border-bottom: none;

        &:after {
            border-bottom-color: ${(props) => props.theme.colors.brand_primary_blue};
        }

        &.k-focus {
            border-color: ${(props) => props.theme.colors.brand_primary_blue};
        }

        .k-input-inner {
            padding-left: 0;
            padding-right: 0;
        }

        .k-button {
            box-shadow: none;

            &:before {
                display: none;
            }

            .k-icon:before {
                content: '\\e015';
            }

            &[aria-label*='collapse'] .k-icon:before {
                content: '\\e013';
            }
        }
    }
`;
